export default __webpack_public_path__ + "9d0ae5c6fa3c32adbe4d0a66df410cc5.jpg";